import AddIcon from '@mui/icons-material/Add';
import { Autocomplete, Button, CircularProgress, List, Paper, Stack, TextField } from '@mui/material';
import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import LocationForm from './LocationForm';
import LocationItem from './LocationItem';
import { addLocation, editLocation, listLocationsWithSlot } from 'FRONTEND/reducers/locationSlice';
import i18n from 'FRONTEND/utils/i18n';

const LOADING_TRIGGER_ACTION_CREATOR_LIST = [
  addLocation.pending,
  editLocation.pending,
  listLocationsWithSlot.pending,
];

const LocationSelector = ({ selectedLocationId, locationList, onLocationSelect, disableCreation }) => {
  const isLoading = useSelector((state) => LOADING_TRIGGER_ACTION_CREATOR_LIST.some((actionCreator) => state.app.requestCounter[actionCreator.toString()] > 0));
  const [openDialog, setOpenDialog] = useState(false);
  const [locationToEdit, setLocationToEdit] = useState(null);

  const selectedLocation = useMemo(() => locationList.find(loc => loc.id === selectedLocationId),
    [locationList, selectedLocationId],
  );


  const handleLocationChange = (event, value) => {
    onLocationSelect(value?.id || '');
  };

  const handleEditLocation = (location) => {
    setLocationToEdit(location);
    setOpenDialog(true);
  };

  return (
    <Stack spacing={2} direction='row' sx={{ alignItems: 'center' }}>
      <Stack spacing={2} direction='row' sx={{ flex: 1, alignItems: 'center' }}>
        <Autocomplete
          sx={{ minWidth: 320, flex: 1 }}
          options={locationList}
          getOptionLabel={(option) => option.description || ''}
          value={selectedLocation || null}
          onChange={handleLocationChange}
          noOptionsText={i18n._('No locations are available')}
          loading={isLoading}
          PaperComponent={(props) => (
            <Paper
              {...props}
              sx={{
                boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
                borderRadius: '4px',
                marginTop: '4px',
              }}
            />
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              label={i18n._('Select a location')}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {isLoading ? <CircularProgress size={24} /> : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
          renderOption={(props, option) => (
            <List {...props} dense key={option.id}>
              <LocationItem
                location={option}
                onEdit={handleEditLocation}
                disableCreation={disableCreation}
              />
            </List>
          )}
        />
        {!disableCreation && (
          <Button
            variant='contained'
            color='primary'
            onClick={() => setOpenDialog(true)}
            startIcon={<AddIcon />}
          >
            {i18n._('Create')}
          </Button>
        )}
      </Stack>

      {!disableCreation &&
        <LocationForm
          open={openDialog}
          onClose={() => {
            setLocationToEdit(null);
            setOpenDialog(false);
          }}
          initialLocation={locationToEdit}
          onLocationCreated={(newLoc) => onLocationSelect(newLoc.id)}
          onLocationEdited={(updatedLoc) => onLocationSelect(updatedLoc.id)}
        />}
    </Stack>
  );
};

export default LocationSelector;
